import React from "react";
import { Button } from "../../components/AdminSharedComponents";
import { Trash2, AlertTriangle } from "lucide-react";

const ProjectDeleteModal = ({
  isOpen,
  project,
  reports,
  onClose,
  onDelete,
}) => {
  if (!isOpen || !project) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0 bg-red-100 rounded-full p-3">
              <AlertTriangle className="h-6 w-6 text-red-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                Delete Project
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                This action cannot be undone
              </p>
            </div>
          </div>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <p className="text-gray-700 font-medium">
              Are you sure you want to delete{" "}
              <span className="text-red-600 font-semibold">
                "{project.name}"
              </span>
              ?
            </p>
            <p className="mt-2 text-sm text-gray-600">
              This project has {reports?.length || 0} associated reports.
            </p>
          </div>

          {reports?.length > 0 && (
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
              <div className="flex items-start gap-2">
                <AlertTriangle className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-amber-800">
                    What should happen to the reports?
                  </p>
                  <p className="text-sm text-amber-700 mt-1">
                    Choose whether to delete the reports or keep them orphaned.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="p-6 border-t border-gray-200 space-y-3">
          <Button
            variant="danger"
            className="w-full flex items-center justify-center gap-2 py-3"
            onClick={() => onDelete(project.id, true)}
          >
            <Trash2 className="h-4 w-4" /> Delete Project & All Reports
          </Button>

          {reports?.length > 0 && (
            <Button
              variant="warning"
              className="w-full flex items-center justify-center gap-2 py-3"
              onClick={() => onDelete(project.id, false)}
            >
              <Trash2 className="h-4 w-4" /> Delete Project Only (Keep Reports)
            </Button>
          )}

          <Button
            variant="secondary"
            className="w-full flex items-center justify-center py-3"
            onClick={onClose}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProjectDeleteModal;
